.ux-w-track-status {
    display: inline-block;
}
